module.exports = __webpack_public_path__ + "img/sd.13c74f57.svg";